<script>
    const DEFAULT_IMAGE_URL = 'https://njerusalem.ru/img/default.jpeg'
    export let title = 'Государственный историко-художественный музей «Новый Иерусалим», официальный сайт',
    keywords = '',
    description = '',
    image = '',
    card = '',
    site = '',
    site_name = '',
    meta_type = '',
    url = '',
    image_height = 675,
    image_width = 1200
</script>


<svelte:head>
    <title>{title}</title>
    <meta name="title" content="{title}"/>
    <meta name="keywords" content="{keywords}" />
    <meta name="description" content="{description}" />
    <meta name="twitter:image" content="{image || DEFAULT_IMAGE_URL}" />
    <meta name="twitter:card" content="{card}" />
    <meta name="twitter:site" content="{site}" />
    <meta name="twitter:title" content="{title}" />
    <meta name="twitter:description" content="{description}"  />
    <meta property="og:site_name" content="{site_name}" />
    <meta property="og:description" content="{description}" />
    <meta property="og:title" content="{title}">
    <meta property="og:type" content="{meta_type}" />
    <meta property="og:url" content="{url}" />

    <meta property="og:image" content="{image || DEFAULT_IMAGE_URL}" />
    <meta property="vk:image"  content="{image || DEFAULT_IMAGE_URL}" />
    <meta property="og:image:height" content="{image_height}" />
    <meta property="og:image:width" content="{image_width}" />
    <link rel="image_src" href="{image || DEFAULT_IMAGE_URL}" />
    <script async src="https://culturaltracking.ru/static/js/spxl.js?pixelId=313" data-pixel-id="313"></script>
</svelte:head>
